import classes from "./navigation.module.scss";

import React from "react";
import { Outlet } from "react-router-dom";

import { Menu } from "./menu";

export type NavigationLayoutProps = {
  children?: React.ReactNode;
};

export const NavigationLayout = ({ children }: NavigationLayoutProps) => {
  const component = children ? children : <Outlet />;

  return (
    <div className={classes["app"]}>
      <Menu hasSystemMessage={false} />
      <div className={classes["main-wrapper"]}>{component}</div>
    </div>
  );
};
